// Identitas merek di SATU tempat. Ganti logo: timpa public/brand/logo.jpg lalu
// `npm run gen-icons` (lihat scripts/generate-icons.js) — ikon di bawah ikut
// terbangkitkan dari file itu. Warna brand ada di tailwind.config.js → colors.brand.
export const BRAND = {
  nama: 'Fast Track',
  // Ikon persegi (latar hitam) — dipakai di header sidebar, login, POS, prompt install.
  logo: '/icons/icon-96.png',
  logoBesar: '/icons/icon-512.png',
};
